/**
 * Resolve a browser-safe download href for an attachment/media object.
 *
 * Prefer same-origin relative paths so downloads work regardless of APP_URL
 * (e.g. edverum.test vs localhost:8000). Preserves external URLs (S3 presigned).
 */
export function resolveMediaDownloadHref(file) {
    if (!file) {
        return null;
    }

    if (file.data) {
        return file.data;
    }

    if (file.public_url) {
        try {
            const parsed = new URL(file.public_url, 'http://localhost');

            // Only rewrite app media routes (`media/{uuid}`: one path segment,
            // no query). Signed storage URLs (S3/MinIO) always carry a query
            // string and must be kept whole, even when a path-style bucket
            // prefix makes the pathname start with /media/.
            if (parsed.search === '' && /^\/media\/[^/]+$/.test(parsed.pathname)) {
                return parsed.pathname;
            }
        } catch {
            // Fall through to the raw URL below.
        }

        return file.public_url;
    }

    if (file.uuid) {
        return `/media/${file.uuid}`;
    }

    return null;
}
